/*
 * @Author: Lucas Fridez
 * @Date: 2019-09-06 07:58:39
 * @LastEditors: Lucas Fridez
 * @LastEditTime: 2019-09-09 11:45:48
 * @Description: file content
 */
// Redux
import { combineReducers, createStore } from "redux";

// Managers
import { NetworkManager, MethodRequest_e } from "./../managers/NetworkManager";

// User Reducer
import userReducer from "./reducers/user/UserReducer";
import * as actionsUserReducer from "./reducers/user/ActionsUserReducer";

// Warehouse Reducer
import warehouseReducer from "./reducers/warehouse/WarehouseReducer";
import * as actionsWarehouseReducer from "./reducers/warehouse/ActionsWarehouseReducer";

//Categories Reducer
import categoriesReducer from "./reducers/categories/CategoriesReducer";
import * as actionCategoriesReducer from "./reducers/categories/ActionsCategoriesReducer";

//Product Listing Reducer
import productListingReducer from "./reducers/products/ProductListingReducer";
import * as actionProductListingReducer from "./reducers/products/ActionsProductListingReducer";

//OverlayReducer
import overlayReducer from "./reducers/overlay/OverlayReducer";
import * as actionsOverlayReducer from "./reducers/overlay/ActionsOverlayReducer";

/**
 * Store mapper
 */
const store = createStore(combineReducers({
    categoriesChecked: categoriesReducer,
    overlay: overlayReducer,
    productListing: productListingReducer,
    user: userReducer,
    warehouses: warehouseReducer
}));

export class MainStore {

    /**
     * @description Return the Redux store
     * @author Lucas Fridez <lfridez@artionet.com>
     * @static
     * @returns redux store
     * @memberof MainStore
     */
    public static getStore() {
        return store;
    }

    public static async getWarehouses() {
        try {
            this.getStore().dispatch({
                type: actionsWarehouseReducer.GET_WAREHOUSES,
                value: await NetworkManager.request("warehouses", MethodRequest_e.GET)
            });
        } catch (error) {
            NetworkManager.showError();
        }
    }

    public static async getProductListing(filter?, location?) {
        this.showOverlay("Récupération du matériel");
        try {
            console.log(`products/listing?${filter}&${location}`);
            this.getStore().dispatch({
                type: actionProductListingReducer.PRODUCT_GET_LISTING,
                value: await NetworkManager.request(filter !== undefined ? `products/listing?${filter}&location=${location}` : "products/listing", MethodRequest_e.GET)
            });
            this.hideOverlay();
        } catch (error) {
            NetworkManager.showError();
        }
    }

    public static updateCategoriesChecked(categoriesChecked) {
        this.getStore().dispatch({
            type: actionCategoriesReducer.CATEGORIES_UPDATE,
            value: categoriesChecked
        });
    }

    public static updateListingLocation(locationId) {
        this.getStore().dispatch({
            type: actionCategoriesReducer.LOCATION_UPDATE,
            value: locationId
        });
    }

    /**
     * @description Login a User
     * @author Lucas Fridez <lfridez@artionet.com>
     * @static
     * @param {any} user user that will be logged in
     * @memberof MainStore
     */
    public static loginUser(user) {
        this.getStore().dispatch({
            type: actionsUserReducer.LOGIN_SUCCESS,
            value: user
        });
    }

    /**
     * @description Login with error
     * @author Lucas Fridez <lfridez@artionet.com>
     * @static
     * @memberof MainStore
     */
    public static loginUserError() {
        this.getStore().dispatch({
            type: actionsUserReducer.LOGIN_ERROR
        });
    }

    /**
     * @description Logout a User
     * @author Lucas Fridez <lfridez@artionet.com>
     * @static
     * @memberof MainStore
     */
    public static logoutUser() {
        this.getStore().dispatch({
            type: actionsUserReducer.LOGOUT
        });
    }

    /**
     * @description Show the Overlay with a custom text
     * @author Lucas Fridez <lfridez@artionet.com>
     * @static
     * @param {string} text text that will be showed
     * @memberof MainStore
     */
    public static showOverlay(text: string, icon = "loading") {
        this.getStore().dispatch({
            icon: icon,
            text: text,
            type: actionsOverlayReducer.SHOW_OVERLAY
        });
    }

    /**
     * @description Hide the overlay and reset the text
     * @author Lucas Fridez <lfridez@artionet.com>
     * @static
     * @memberof MainStore
     */
    public static hideOverlay() {
        this.getStore().dispatch({
            type: actionsOverlayReducer.HIDE_OVERLAY
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/store/MainStore.ts